import { Package } from '@frontend/package/types';
import { MobileWizardStateData, MobileWizardStateRecord } from '@frontend/wizard/mobile';

export function hasNavigationEntityContext(locationState: unknown): boolean {
    if (!locationState || typeof locationState !== 'object') return false;

    const state = locationState as Record<string, unknown>;
    return !!(
        state.transaction ||
        state.package ||
        (Array.isArray(state.packages) && state.packages.length > 0) ||
        state.colli ||
        (Array.isArray(state.collis) && state.collis.length > 0)
    );
}

export function resolveNavigationWizardData(locationState: unknown): MobileWizardStateData {
    if (!locationState || typeof locationState !== 'object') return {};

    const state = locationState as Record<string, unknown>;
    const data: MobileWizardStateData = {};

    if (state.transaction) data.transaction = state.transaction;
    if (state.package) data.package = state.package;
    if (state.packages) data.packages = state.packages;
    if (state.colli) data.colli = state.colli;
    if (state.collis) data.collis = state.collis;

    return data;
}

export function hasWizardEntityContext(store: MobileWizardStateRecord | null): boolean {
    if (!store) return false;

    const { data } = store;
    return !!(data.transaction || data.package || data.packages?.length || data.collis?.length || data.colli);
}

export function resolveCurrentPackage(store: MobileWizardStateRecord | null): Partial<Package> | null {
    if (!store) return null;

    const { data } = store;

    if (data.package) {
        return data.package as Partial<Package>;
    }

    const packages = (data.packages as Partial<Package>[] | undefined) ?? [];
    if (packages.length > 0) {
        const packageWithProof = packages.find((pkg) => pkg.require_proof_of_identity);
        return packageWithProof ?? packages[0];
    }

    return null;
}
